import dashboardData from '../assets/json/dashboardData.json';

/**
 * Dashboard data service.
 * Currently reads from local JSON so content can move to an API later
 * without changing page components — only swap the fetch implementation.
 *
 * Future API example:
 *   const response = await axiosAdapter.get('/dashboard');
 *   return response.data;
 */
export async function getDashboardData() {
  // Simulate async so callers already use await / Promise patterns for API swap
  return Promise.resolve(dashboardData);
}

export function getDashboardDataSync() {
  return dashboardData;
}

export default {
  getDashboardData,
  getDashboardDataSync,
};
